import { z } from 'zod'

/* Companies-API */

/**
 * Type for 'AlarmSettingsResponseDto' (backend API data type).
 */
export interface AlarmSettingsResponse {
  emailEnabled: boolean
  emailInterval: number
  emailRecipients: string[]
  smsEnabled: boolean
  smsInterval: number
  smsRecipients: string[]
  temperatureAlertsEnabled: boolean
  temperatureAlertLowerLimit: number
  temperatureAlertUpperLimit: number
}

/**
 * Schema for 'AlarmSettingsResponseDto' (backend API data type).
 */
export const AlarmSettingsResponseSchema = z.object({
  emailEnabled: z.boolean(),
  emailInterval: z.number(),
  emailRecipients: z.array(z.string()),
  smsEnabled: z.boolean(),
  smsInterval: z.number(),
  smsRecipients: z.array(z.string()),
  temperatureAlertsEnabled: z.boolean(),
  temperatureAlertLowerLimit: z.number(),
  temperatureAlertUpperLimit: z.number()
})

/**
 * Type for 'CheckUserDetailsDto' (backend API data type).
 */
interface CheckUserResponseDetails {
  username: string
  systemAdmin: boolean
}

/**
 * Type for 'CompanyUserResponseItem' (backend API data type).
 */
interface CompanyUserResponseItem {
  username: string
}

/**
 * Type for 'UsersOwnCompanyResponse' (backend API data type).
 */
interface OwnCompanyResponse {
  id: string
  name: string
  users: CompanyUserResponseItem[]
}

/**
 * Type for 'CheckUserResponseDto' (backend API data type).
 */
export interface CheckUserResponsePayload {
  user: CheckUserResponseDetails
  ownCompany?: OwnCompanyResponse
  assignedToCompany: boolean
  deleted: boolean
}

/**
 * Schema for 'CheckUserResponseDto' (backend API data type).
 */
export const CheckUserResponseSchema = z.object({
  user: z.object({
    username: z.string(),
    systemAdmin: z.boolean()
  }),
  ownCompany: z.object({
    id: z.string(),
    name: z.string(),
    users: z.array(z.object({
      username: z.string()
    }))
  }).nullish().transform(it => it ?? undefined),
  assignedToCompany: z.boolean(),
  deleted: z.boolean()
})
